import $ from "jquery";

const className = 'accordion__heading';
const selector_trigger = '.accordion__heading';
const selector_target = '.accordion__content';

function toggleItem($element: JQuery): void {
	if ($element.parent().hasClass('target')) {
		$element.parent().removeClass('target');
		$element.next().stop(true).slideUp();
	} else {
		$element.parent().addClass('target');
		$element.next().stop(true).slideDown();
	}
}

function toggleItemTargeted($item: JQuery): void {
	const id = (window.location.hash).replace(/([.:])/, '\\$1');
	const $targetedElement = $item.find(id);

	if ($targetedElement.hasClass(className)) {
		toggleItem($targetedElement);
	}
}

function setupIcons($item: JQuery) {
	$item.find(selector_trigger).append(`
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26" height="26">
			<path class="svg-path-v" d="M12 5h2v16h-2z"/>
			<path class="svg-path-h" d="M5 12h16v2H5z"/>
		</svg>
	`);
}

function setupEventHandlers($item: JQuery) {
	$item.on('click', selector_trigger, event => {
		event.preventDefault();
		const dest = new URL(location.toString());
		dest.hash = event.currentTarget.id;
		history.replaceState(undefined, '', dest.toString());
		toggleItem($(event.currentTarget));
	});
}

function wireUpaccordion(accordion: HTMLElement) {
	const $item = $(accordion);

	setupIcons($item);
	setupEventHandlers($item);
	$item.addClass('js-ready');
	$item.find(selector_trigger).siblings(selector_target).slideUp({duration: 0, done: () => toggleItemTargeted($item)});
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll<HTMLElement>('.accordion').forEach(wireUpaccordion);
	new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const addedNode of mutation.addedNodes) {
				if (addedNode instanceof HTMLElement) {
					if (addedNode.classList.contains("accordion")) {
						wireUpaccordion(addedNode);
					}
					addedNode.querySelectorAll<HTMLElement>('.accordion').forEach(wireUpaccordion);
				}
			}
		}
	}).observe(document, {subtree: true, childList: true});
});
